export const SET_GAP_ACTIONS_LIST = "SET_GAP_ACTIONS_LIST";
export function action_setGapActions(value) {
	return { type: SET_GAP_ACTIONS_LIST, payload: value };
}

export const SET_GAP_SELECTED_ACTION_TO_DIALOG = "SET_GAP_SELECTED_ACTION_TO_DIALOG";
export function action_setGapSelectedActionToDialog(value) {
	return { type: SET_GAP_SELECTED_ACTION_TO_DIALOG, payload: value };
}

export const SET_GAP_CAUSE_LIST = "SET_GAP_CAUSE_LIST";
export function action_setGapCauses(value) {
	return { type: SET_GAP_CAUSE_LIST, payload: value };
}

export const UPDATE_BOARD_EVENT = "UPDATE_BOARD_EVENT";
export function action_setEvents(value) {
	return { type: UPDATE_BOARD_EVENT, payload: value };
}

export const UPDATE_BOARD_CHART_SELECTED_DATAPOINT = "UPDATE_BOARD_CHART_SELECTED_DATAPOINT";
export function action_updateChartSelectedDatapoint(value) {
	return { type: UPDATE_BOARD_CHART_SELECTED_DATAPOINT, payload: value };
}

export const UPDATE_BOARD_CHART = "UPDATE_BOARD_CHART";
export function action_updateChartAction(update, chart) {
	return { type: UPDATE_BOARD_CHART, payload: { update, chart} };
}

export const UPDATE_BOARD_CHART_TO_COMPARE = "UPDATE_BOARD_CHART_TO_COMPARE";
export function action_updateChartActionCompare(update, chart) {
	return { type: UPDATE_BOARD_CHART_TO_COMPARE, payload: { update, chart} };
}

export const UPDATE_BOARD_COMPONENT_INFO_TO_COMPARE = "UPDATE_BOARD_COMPONENT_INFO_TO_COMPARE";
export function action_updateComponentInfoDataCompare(object, update) {
	return { type: UPDATE_BOARD_COMPONENT_INFO_TO_COMPARE, payload: { object, update} };
}

export const UPDATE_BOARD_COMPONENT_INFO = "UPDATE_BOARD_COMPONENT_INFO";
export function action_updateComponentInfoData(object, update) {
	return { type: UPDATE_BOARD_COMPONENT_INFO, payload: { object, update }};
}

export const UPDATE_BOARD_COMPONENT_INFO_CHART_COMPARE = "UPDATE_BOARD_COMPONENT_INFO_CHART_COMPARE";
export function action_updateComponentInfoDataChartCompare(object, chart, update) {
	return { type: UPDATE_BOARD_COMPONENT_INFO_CHART_COMPARE, payload: { object, chart, update }};
}


export const SET_BOARD = "SET_BOARD";
export function action_setBoard(object) {
	return { type: SET_BOARD, payload: { object } };
}

export const SET_BOARD_STRUCTURE = "SET_BOARD_STRUCTURE";
export function action_setBoardStructure(object) {
	return { type: SET_BOARD_STRUCTURE, payload: { object } };
}

export const UPDATE_BOARD_TIME_AGGREGATION = "UPDATE_BOARD_TIME_AGGREGATION";
export function action_updateBoardTimeAggregation(object) {
	return { type: UPDATE_BOARD_TIME_AGGREGATION, payload: { object } };
}

export const UPDATE_BOARD_TEMPLATE_TYPE = "UPDATE_BOARD_TEMPLATE_TYPE";
export function action_updateBoardTemplateType(object) {
	return { type: UPDATE_BOARD_TEMPLATE_TYPE, payload: { object } };
}

export const UPDATE_BOARD = "UPDATE_BOARD";
export function action_updateBoard(object) {
	return { type: UPDATE_BOARD, payload: { object } };
}

export const UPDATE_BOARD_NAME = "UPDATE_BOARD_NAME";
export function action_updateBoardName(object) {
	return { type: UPDATE_BOARD_NAME, payload: { object } };
}

export const UPDATE_BOARD_FULL_STRUCTURE = "UPDATE_BOARD_FULL_STRUCTURE";
export function action_updateBoardFullStructure(object) {
	return { type: UPDATE_BOARD_FULL_STRUCTURE, payload: { object } };
}

export const UPDATE_BOARD_FULL_STRUCTURE_CONTAINERS = "UPDATE_BOARD_FULL_STRUCTURE_CONTAINERS";
export function action_updateBoardFullStructureNewContainers(object) {
	return { type: UPDATE_BOARD_FULL_STRUCTURE_CONTAINERS, payload: { object } };
}

export const UPDATE_BOARD_FULL_STRUCTURE_NEW_TEMPORAL = "UPDATE_BOARD_FULL_STRUCTURE_NEW_TEMPORAL";
export function action_updateBoardFullStructureNewTemporal(object, flag) {
	return { type: UPDATE_BOARD_FULL_STRUCTURE_NEW_TEMPORAL, payload: { object, flag } };
}

export const SET_BOARD_DATASERIES = "SET_BOARD_DATASERIES";
export function action_setBoardDataseries(object) {
	return { type: SET_BOARD_DATASERIES, payload: { object } };
}

export const UPDATE_BOARD_DATASERIES_LIST = "UPDATE_BOARD_DATASERIES_LIST";
export function action_updateBoardDataseriesList(object, update) {
	return { type: UPDATE_BOARD_DATASERIES_LIST, payload: { object, update } };
}

export const UPDATE_BOARD_DATASERIE = "UPDATE_BOARD_DATASERIE";
export function action_updateBoardDataserie(object, update) {
	return { type: UPDATE_BOARD_DATASERIE, payload: { object, update } };
}

export const UPDATE_BOARD_DATASERIES_LIST_ASSOCIATION = "UPDATE_BOARD_DATASERIES_LIST_ASSOCIATION";
export function action_updateBoardContainerDataserieAssociation(objectList) {
	return { type: UPDATE_BOARD_DATASERIES_LIST_ASSOCIATION, payload: objectList };
}

export const UPDATE_BOARD_CONTAINER_TITLE = "UPDATE_BOARD_CONTAINER_TITLE";
export function action_setBoardContainerTitle(containerId, title) {
	return { type: UPDATE_BOARD_CONTAINER_TITLE, payload: { containerId, title } };
}

export const SET_BOARD_SCOPE_VALUES = "SET_BOARD_SCOPE_VALUES";
export function action_setBoardScopeValues(objectList) {
	return { type: SET_BOARD_SCOPE_VALUES, payload: objectList };
}

export const UPDATE_BOARD_MOVE_ZONES = "UPDATE_BOARD_MOVE_ZONES";
export function action_setBoardMoveZones(moveZones) {
	return { type: UPDATE_BOARD_MOVE_ZONES, payload: moveZones };
}

export const CLEAR_BOARD_CONTEXT = "CLEAR_BOARD_CONTEXT";
export function action_clearBoardContext() {
	return { type: CLEAR_BOARD_CONTEXT, payload: null };
}

export const CLEAR_DATASERIE_CONTEXT = "CLEAR_DATASERIE_CONTEXT";
export function action_clearDataserieContext() {
	return { type: CLEAR_DATASERIE_CONTEXT, payload: null };
}

export const SET_REPORT_COMPONENTS_TYPETEXT = "SET_REPORT_COMPONENTS_TYPETEXT";
export function action_setReportComponents_TypeText_Context(componentsData) {
	return { type: SET_REPORT_COMPONENTS_TYPETEXT, payload: componentsData };
}












//START MANTAINER

export const SET_CONTRACT_PROPS = "SET_CONTRACT_PROPS";
export function action_setContractProps(contractPropList) {
	return { type: SET_CONTRACT_PROPS, payload: contractPropList };
}

export const SET_CONTRACT_PROP_LIST_VALUES = "SET_CONTRACT_PROP_LIST_VALUES";
export function action_setContractPropListValues(contractPropListValues) {
	return { type: SET_CONTRACT_PROP_LIST_VALUES, payload: contractPropListValues };
}

export const SET_CONTRACT_PROP_VALUE_SELECTED = "SET_CONTRACT_PROP_VALUE_SELECTED";
export function action_setContractPropValueSelected(contractPropValueIdSelected) {
	return { type: SET_CONTRACT_PROP_VALUE_SELECTED, payload: contractPropValueIdSelected };
}

//END MANTAINER



//START VARIABLE

export const SET_VARIABLE_LIST = "SET_VARIABLE_LIST";
export function action_setVariableList(variableList) {
	return { type: SET_VARIABLE_LIST, payload: variableList };
}

export const SET_VARIABLE_ITEM = "SET_VARIABLE_ITEM";
export function action_setVariableItem(variableItem) {
	return { type: SET_VARIABLE_ITEM, payload: variableItem };
}

export const SET_FILTRED_VARIABLE_LIST = "SET_FILTRED_VARIABLE_LIST";
export function action_setFiltredVariableList(variableList) {
	return { type: SET_FILTRED_VARIABLE_LIST, payload: variableList };
}

//END VARIABLE



//START BOARD CONFIG

export const SET_TEMPLATETYPE_LIST = "SET_TEMPLATETYPE_LIST";
export function action_setBoardConfigTemplateTypeList(templateTypeList) {
	return { type: SET_TEMPLATETYPE_LIST, payload: templateTypeList };
}

export const SET_APPELEMENT_LIST = "SET_APPELEMENT_LIST";
export function action_setBoardConfigAppElementList(appElementList) {
	return { type: SET_APPELEMENT_LIST, payload: appElementList };
}

export const SET_ELEMENT_LIST = "SET_ELEMENT_LIST";
export function action_setBoardConfigElementList(elementList) {
	return { type: SET_ELEMENT_LIST, payload: elementList };
}

export const SET_COMPONENT_STRUCTURE = "SET_COMPONENT_STRUCTURE";
export function action_setBoardConfigComponentStructure(componentStructure) {
	return { type: SET_COMPONENT_STRUCTURE, payload: componentStructure };
}

export const SET_TEMPLATE_STRUCTURE = "SET_TEMPLATE_STRUCTURE";
export function action_setBoardConfigTemplateStructure(templateStructure) {
	return { type: SET_TEMPLATE_STRUCTURE, payload: templateStructure };
}

export const SET_TEMPLATE_CONFIG_PROPERTY = "SET_TEMPLATE_CONFIG_PROPERTY";
export function action_setBoardConfigTemplateProperty(fieldName, value) {
	return { type: SET_TEMPLATE_CONFIG_PROPERTY, payload: {fieldName: fieldName, value: value} };
}

//END BOARD CONFIG



//START BOARD VIEW


export const SET_PAGE_STATE = "SET_PAGE_STATE";
export function action_setPageState(state) {
	return { type: SET_PAGE_STATE, payload: state };
}


export const SET_ALL_NULL = "SET_ALL_NULL";
export function action_setAllBoardViewNull() {
	return { type: SET_ALL_NULL, payload: null };
}

export const SET_BOARD_ELEMENT_ID = "SET_BOARD_ELEMENT_ID";
export function action_setBoardViewElementId(elementId) {
	return { type: SET_BOARD_ELEMENT_ID, payload: elementId	};
}

export const SET_BOARD_STRUCTURE_GENERIC = "SET_BOARD_STRUCTURE_GENERIC";
export function action_setBoardViewStructureGeneric(boardStructureGeneric, elementId) {
	return { type: SET_BOARD_STRUCTURE_GENERIC, payload:
		{
			boardStructureGeneric: boardStructureGeneric,
			elementId: elementId
		}
	};
}

export const SET_BOARD_STRUCTURE_SPECIFIC = "SET_BOARD_STRUCTURE_SPECIFIC";
export function action_setBoardViewStructureSpecific(boardStructureSpecific, elementId) {
	return { type: SET_BOARD_STRUCTURE_SPECIFIC, payload:
		{
			boardStructureSpecific: boardStructureSpecific,
			elementId: elementId
		}
	};
}

export const SET_BOARD_STRUCTURE_SPECIFIC_BASE = "SET_BOARD_STRUCTURE_SPECIFIC_BASE";
export function action_setBoardViewStructureSpecificBase(boardStructureSpecific) {
	return { type: SET_BOARD_STRUCTURE_SPECIFIC_BASE, payload: boardStructureSpecific };
}

export const SET_BOARD_CHARTGAUGE_SELECTED_DATAPOINT = "SET_BOARD_CHARTGAUGE_SELECTED_DATAPOINT";
export function action_setBoardChartGaugeSelectedDataPoint(boardComponentInfoValues) {
	return { type: SET_BOARD_CHARTGAUGE_SELECTED_DATAPOINT, payload: boardComponentInfoValues };
}

export const SET_BOARD_COMPONENT_INFO_RECURSIVEVALUES = "SET_BOARD_COMPONENT_INFO_RECURSIVEVALUES";
export function action_setBoardViewComponentInfoRecursiveValues(componentTypeEnumName, boardComponentInfoRecursiveValues) {
	const returnValue = { componentTypeEnumName: componentTypeEnumName, data: boardComponentInfoRecursiveValues };
	return { type: SET_BOARD_COMPONENT_INFO_RECURSIVEVALUES, payload: returnValue };
}

export const SET_BOARD_COMPONENT_INFO_FULL = "SET_BOARD_COMPONENT_INFO_FULL";
export function action_setBoardViewComponentInfoFull(boardComponentInfoRecursiveValues) {
	return { type: SET_BOARD_COMPONENT_INFO_FULL, payload: { data: boardComponentInfoRecursiveValues, filled: true }};
}

export const SET_BOARD_CONTRACT_FILTER_COMPONENTS_AND_SYNC_FLAG = "SET_BOARD_CONTRACT_FILTER_COMPONENTS_AND_SYNC_FLAG";
export function action_setBoardContractFilterComponents_And_Sync_Flag(filters, flag) {
	return { type: SET_BOARD_CONTRACT_FILTER_COMPONENTS_AND_SYNC_FLAG, payload: { filters, flag } };
}

export const SET_BOARD_CONTRACT_FILTER_COMPONENTS = "SET_BOARD_CONTRACT_FILTER_COMPONENTS";
export function action_setBoardContractFilterComponents(filters) {
	return { type: SET_BOARD_CONTRACT_FILTER_COMPONENTS, payload: filters };
}

export const SET_BOARD_CONTRACT_FILTER_COMPONENTS_SYNC_FLAG = "SET_BOARD_CONTRACT_FILTER_COMPONENTS_SYNC_FLAG";
export function action_setBoardContractFilterComponentSycFlag(syncFlag) {
	return { type: SET_BOARD_CONTRACT_FILTER_COMPONENTS_SYNC_FLAG, payload: syncFlag };
}

export const SET_BOARD_VARIABLE_DATASERIE_VALUES = "SET_BOARD_VARIABLE_DATASERIE_VALUES";
export function action_setBoardViewVariableDataserieValues(boardVariableDataserieValues) {
	return { type: SET_BOARD_VARIABLE_DATASERIE_VALUES, payload: boardVariableDataserieValues };
}

export const SET_BOARD_ELEMENTS = "SET_BOARD_ELEMENTS";
export function action_setBoardElements(boardElements) {
	return { type: SET_BOARD_ELEMENTS, payload: boardElements };
}

export const SET_BOARD_CHARTS_CONTAINERID_SELECTED = "SET_BOARD_CHARTS_CONTAINERID_SELECTED";
export function action_setBoardChartContainerIdSelected(boardElements) {
	return { type: SET_BOARD_CHARTS_CONTAINERID_SELECTED, payload: boardElements };
}

export const SET_BOARD_ELEMENT_ROLES = "SET_BOARD_ELEMENT_ROLES";
export function action_setBoardElementRoles(boardElementRoles, systemRoles) {
	return { type: SET_BOARD_ELEMENT_ROLES, payload: { boardElementRoles, systemRoles} };
}
//END BOARD VIEW